import styled from 'styled-components';

export const ColumnsHolder = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SortItem = styled.div`
  background: #ebeff3;
  border-radius: 4px;
  padding: 4px 6px;
  font-weight: 600;
  font-size: 12px;
  color: #12344d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    margin-left: 31px;
    width: calc(100% - 31px);
    :not(:last-child) {
      margin-bottom: 16px;
    }
  }
  div.close-action {
    cursor: pointer;
    width: 20px;
    height: 20px;
    padding: 0px 6px;
  }
`;

export const ScrollContainer = styled.div`
  flex-grow: 1;
  overflow: auto;
  padding-left: 6px;
  scroll-behavior: smooth;
`;

export const SplitScreen = styled.div`
  height: 100%;
  display: flex;
  flex-grow: 1;
  overflow: auto;
  div.pd-left {
    padding-left: 6px;
  }
  div.left-pane {
    overflow: auto;
    border-right: 1px solid #ececec;
    width: 50%;
    padding-left: 6px;
    padding-right: 16px;
    display: flex;
    flex-direction: column;
  }
  div.right-pane {
    padding-left: 16px;
    width: 50%;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
`;
